import { Attributes, ModelBase, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class DividendWithholdingTaxLookup extends ModelBase {

  public brokerAccountNumber: string = "";

  public instrument: string = "";

  public eventDetail: string = "";

  public eventId: string = "";

  @Attributes.Date()
  public eventDate: Date = new Date();

  public amountNC: number | null = null;

  public excluded: boolean | null = null;
}